import COLORS from '../../utils/constants/colors'

const confirmEmailPageStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
  link: {
    color: COLORS.purple,
    alignSelf: 'flex-start',
  },
}

export default confirmEmailPageStyles
